export default "__VITE_ASSET__9517002d__"